import {
  INSERT_OTP_SUCCESS,
  INSERT_OTP_FAILED,
  INSERT_OTP_ALREADY_REGISTERED,
  INSERT_OTP_INVALID_PASSWORD,
  RESET_INSERT_OTP,
  LOADING_INSERT_OTP
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  alreadyRegistered: false,
  invalidPassword: false,
  status: "",
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_INSERT_OTP:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidPassword: false,
        alreadyRegistered: false,
        networkError: "",
        status: ""
      };
    case INSERT_OTP_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidPassword: false,
        alreadyRegistered: false,
        networkError: "",
        status: action.payload
      };

    case INSERT_OTP_INVALID_PASSWORD:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        invalidPassword: true,
        alreadyRegistered: false,
        networkError: "",
        status: action.payload
      };

    case INSERT_OTP_ALREADY_REGISTERED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidPassword: false,
        alreadyRegistered: true,
        failed: false,
        networkError: "",
        status: action.payload
      };
    case INSERT_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        invalidPassword: false,
        success: true,
        alreadyRegistered: false,
        failed: false,
        networkError: "",
        status: ""
      };

    case RESET_INSERT_OTP:
      return (state = initialState);

    default:
      return state;
  }
};
